import classNames from 'classnames';
import Link from 'next/link';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import css from './BooksWaitingListAlert.module.scss';

const BooksWaitingListAlert = () => {
  const classes = classNames(css.BooksWaitingListAlert);
  const intl = useIntl();
  return (
    <div className={classes}>
      <p className={css.BooksWaitingListAlert__Paragraph}>
        {intl.formatMessage({ id: 'books.forms.waitingListAlertMessage1' })}
        <br />
        {intl.formatMessage({ id: 'books.forms.waitingListAlertMessage2' })}
      </p>
      <p className={css.BooksWaitingListAlert__Paragraph}>
        <FormattedMessage
          id="books.forms.waitingListAlertMessage3"
          values={{
            terms: (
              <Link
                href="/terms"
                prefetch={false}
                className={css.BooksWaitingListAlert__Link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {intl.formatMessage({ id: 'books.forms.termOfUse' })}
              </Link>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default BooksWaitingListAlert;
